import { Button, Checkbox, Input, Modal } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export default function SaveFilterDialog({ open, onClose, onSave, filterCount }) {
  const { t } = useTranslation();
  const [name, setName] = useState("");
  const [isDefault, setIsDefault] = useState(false);

  const handleSave = () => {
    if (name.trim()) {
      onSave(name.trim(), isDefault);
      setName("");
      setIsDefault(false);
    }
  };

  const handleCancel = () => {
    setName("");
    setIsDefault(false);
    onClose();
  };

  return (
    <Modal
      title={t("common.saveFilter")}
      open={open}
      onOk={handleSave}
      onCancel={handleCancel}
      okText={t("common.save")}
      cancelText={t("common.cancel")}
      okButtonProps={{ disabled: !name.trim() }}>
      <div className="space-y-4">
        <div>
          <label className="block mb-2 text-sm font-medium">
            {t("common.filterName")}
          </label>
          <Input
            placeholder={t("common.enterFilterName")}
            value={name}
            onChange={(e) => setName(e.target.value)}
            onPressEnter={handleSave}
          />
        </div>
        <div>
          <Checkbox
            checked={isDefault}
            onChange={(e) => setIsDefault(e.target.checked)}>
            {t("common.setAsDefault")}
          </Checkbox>
        </div>
        <div className="text-sm text-gray-500">
          {t("common.filterCount", { count: filterCount })}
        </div>
      </div>
    </Modal>
  );
}
